import { render, staticRenderFns } from "./ModalCreateInvoice.vue?vue&type=template&id=0b3cbfde"
import script from "./ModalCreateInvoice.vue?vue&type=script&lang=js"
export * from "./ModalCreateInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports